export default {
  userLabel: 'email',
  userService: '/bcare/users',
};
